<template>
  <div class="admin-categories">
    <header-title title="Subcategorías"></header-title>

    <div class="category-btn">
      <v-btn
        dense
        outlined
        @click="openSubCatDialog('addSubCat')"
        :style="adminNavigationBackTheme"
      >
        + Nueva
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            label="Buscar"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            v-model="subCategorySelected"
            :items="subCategoriesCollection"
            item-text="name"
            item-value="id"
            label="SubCategoría"
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            v-model="categorySelected"
            :items="categoriesCollection"
            item-text="name"
            item-value="id"
            label="Categoría"
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col cols="12" justify="center" sm="6" md="3" lg="2">
          <button
            class="admin-reset-filters"
            @click="resetFilters"
            :style="adminResetFiltersTheme"
          >
            Borrar Filtros
          </button>
        </v-col>
      </v-row>
    </v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="sortSubCategories(subCategories)"
          class="elevation-1"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.category_id`]="{ item }">
            <v-btn
              rounded
              dark
              :x-small="true"
              class="subcategory-info"
              :style="{ 'background-color': categoryTagBackgroundTheme }"
            >
              {{ getCategory(item.category_id) }}
            </v-btn>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openSubCatDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>
          <template v-slot:[`item.deleteAction`]="{ item }">
            <v-icon class="mr-2" @click="deleteSubCategoryDialog(item.id)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <SubCategoryDialog ref="subCategoryDialog"></SubCategoryDialog>

    <v-row justify="center">
      <DeleteSubCategoryDialog
        :dialog="dialog"
        @cancel="deleteCancel"
        @deleteSubCategories="deleteSubCategories"
      ></DeleteSubCategoryDialog>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import { orderBy } from "lodash";
import SubCategoryDialog from "../../../components/admin/subcategory/SubCategoryDialog";
import DeleteSubCategoryDialog from "@/components/admin/subcategory/DeleteSubCategoryDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { SubCategoriesTableHeader } from "@/utils/tableHeaderconstants";
import { productTypesCollection } from "@/collections/productTypes";
import {
  deleteSubCategory,
  subCategoriesCollection
} from "@/collections/subCategories";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";
import { drinksCollection } from "@/collections/drinks";
import { categoriesCollection } from "@/collections/categories";
// eslint-disable-next-line no-unused-vars
let fromRoute = undefined;
export default {
  name: "sub-categories",
  components: {
    SubCategoryDialog,
    DeleteSubCategoryDialog,
    HeaderTitle
  },
  data() {
    return {
      search: "",
      categoriesCollection: [],
      subCategoriesCollection: [],
      drinksCollection: [],
      foodCollection: [],
      dessertCollection: [],
      productTypesCollection: [],
      subCategorySelected: "",
      categorySelected: "",
      dialog: false,
      selectedSubCategoryId: null,
      headers: [...SubCategoriesTableHeader]
    };
  },
  firestore() {
    return {
      categoriesCollection: categoriesCollection,
      subCategoriesCollection: subCategoriesCollection,
      drinksCollection: drinksCollection,
      foodCollection: foodCollection,
      dessertCollection: dessertCollection,
      productTypesCollection: productTypesCollection
    };
  },
  computed: {
    subCategories() {
      if (this.categorySelected !== "" && this.subCategorySelected !== "") {
        return this.subCategoriesCollection.filter(
          subcategory =>
            this.subCategorySelected === subcategory.id &&
            this.categorySelected === subcategory.category_id
        );
      }

      if (this.categorySelected !== "") {
        return this.subCategoriesCollection.filter(
          subcategory => this.categorySelected === subcategory.category_id
        );
      }

      return this.subCategorySelected !== ""
        ? this.subCategoriesCollection.filter(
            subcategory => this.subCategorySelected === subcategory.id
          )
        : this.subCategoriesCollection;
    }
  },
  mounted() {
    setTimeout(() => {}, 2000);
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  },
  methods: {
    getCategory(id) {
      return this.getCategoryName(this.categoriesCollection, id);
    },
    sortSubCategories(subCategories) {
      return (
        subCategories &&
        orderBy(
          subCategories,
          o => {
            return moment(
              o.updated_on ||
                moment()
                  .subtract(1, "M")
                  .format()
            );
          },
          ["desc"]
        )
      );
    },
    resetFilters() {
      this.categorySelected = "";
      this.subCategorySelected = "";
    },
    openSubCatDialog(itemId) {
      this.itemId = itemId;
      this.$refs.subCategoryDialog.open(itemId);
    },
    deleteSubCategories() {
      let subCategory = this.subCategoriesCollection.find(
        element => this.selectedSubCategoryId === element.id
      );

      let category = this.categoriesCollection.find(
        element => subCategory.category_id === element.id
      );

      if (
        category.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID
      ) {
        this.deleteOrShowToast(
          this.foodCollection,
          category.id,
          subCategory.id
        );
        return;
      }

      if (
        category.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID
      ) {
        this.deleteOrShowToast(
          this.drinksCollection,
          category.id,
          subCategory.id
        );
        return;
      }

      if (
        category.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
      ) {
        this.deleteOrShowToast(
          this.dessertCollection,
          category.id,
          subCategory.id
        );
        return;
      }

      this.deleteSubCategoryById(subCategory.id);
    },
    deleteOrShowToast(collection, categoriesId, subCategoriesId) {
      let productNames = [];
      collection
        .filter(element => subCategoriesId === element.sub_category_id)
        .forEach(element => {
          productNames.push(element.name);
        });

      if (productNames.length > 0) {
        let title = `Esta subcategoría está asignada al producto: ${productNames.join(
          ","
        )}`;
        this.showErrorMessage(title);
        return;
      }

      this.deleteSubCategoryById(subCategoriesId);
    },
    async deleteSubCategoryById(subCategoriesId) {
      try {
        await deleteSubCategory(subCategoriesId);
        this.selectedSubCategoryId = null;
        this.dialog = false;
      } catch (error) {
        this.setlogError(
          "delete_sub_category",
          "Obtained error message in deleteSubCategoryById()",
          error.stack,
          this.$options.name
        );
        this.dialog = false;
      }
    },
    deleteSubCategoryDialog(id) {
      this.selectedSubCategoryId = id;
      this.dialog = true;
    },
    deleteCancel() {
      this.dialog = false;
    }
  }
};
</script>

<style>
.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}
</style>
